import * as React from 'react';
import CoubicShortLogo from '../../../atoms/logos/CoubicShortLogo';
import css from './ServiceFooterLogo.module.scss';

const ServiceFooterLogo = () => {
  return (
    <div className={css.ServiceFooterLogo}>
      <a href="/" className={css.ServiceFooterLogo__Logo}>
        <CoubicShortLogo className={css.ServiceFooterLogo__LogoImg} />
      </a>
    </div>
  );
};

export default ServiceFooterLogo;
